export const strings = {
	// phones must only have numbers
	phone: "08007020124",
	phone2: "08000220130",
	phone3: "08007020124"
};
